




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Avatar extends Vue {
  @Prop() color!: string;
  @Prop() icon?: string;
  @Prop() svgIcon?: string;
  @Prop() thumbUrl?: string;
  @Prop() borderColor?: string;

  @Prop({ default: false }) small: boolean;
  @Prop({ default: false }) xSmall: boolean;
  @Prop({ default: false }) shadow?: boolean;

  defaultAvatar: string = 'default-avatar';
  brokenImage: boolean = false;

  get showOriginalThumb(): boolean {
    return this.thumbUrl && !this.brokenImage;
  }

  handleImageError() {
    this.brokenImage = true;
  }
}
